import React from "react";
import {
  Box,
  Drawer,
  AppBar,
  CssBaseline,
  Toolbar,
  Card,
  CardActions,
  CardContent,
  Button,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
// import AlertEvent from "./AlertEvent";

const drawerWidth = 240;
const eventWidth = 200;

const Content = ({ children }) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 3,
        width: { sm: `calc(100% - ${drawerWidth + eventWidth}px)` },
      }}
    >
      <Toolbar />
      {children}
      {/* <AlertEvent /> */}
    </Box>
  );
};

export default Content;
